import type { Announcement } from '../types';

export function latestAnnouncementSentAt(announcements: Announcement[]): string | null {
  let latest: string | null = null;
  for (const item of announcements) {
    const sentAt = item.sentAt || item.createdAt;
    if (!sentAt) continue;
    if (!latest || new Date(sentAt).getTime() > new Date(latest).getTime()) {
      latest = sentAt;
    }
  }
  return latest;
}

export function countUnreadAnnouncements(
  announcements: Announcement[],
  lastReadAt: string | null,
  initialized: boolean,
): number {
  if (announcements.length === 0) return 0;
  if (!initialized || !lastReadAt) return 0;

  const readMs = new Date(lastReadAt).getTime();
  if (Number.isNaN(readMs)) return announcements.length;

  return announcements.filter((item) => {
    const sentAt = item.sentAt || item.createdAt;
    if (!sentAt) return false;
    return new Date(sentAt).getTime() > readMs;
  }).length;
}
